export default "__VITE_ASSET__DRsPUswH__"